module.exports = __webpack_public_path__ + "img/head.2b6b0e9c.png";